var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "ticket-item",
      attrs: { type: "button", tabindex: "0" },
      on: {
        click: function ($event) {
          return _vm.$emit("click-status", _vm.item)
        },
      },
    },
    [
      _c("div", { staticClass: "ticket-main" }, [
        _c("div", { staticClass: "ticket-top" }, [
          _c("span", { staticClass: "category-chip" }, [
            _vm._v(_vm._s(_vm.item.category || "-")),
          ]),
          _c("strong", [
            _vm._v(
              _vm._s(_vm.item.ticketNo || _vm.item.aqId || _vm.item.outline)
            ),
          ]),
        ]),
        _c("p", [_vm._v(_vm._s(_vm.item.outline))]),
      ]),
      _c("div", { staticClass: "ticket-meta" }, [
        _c(
          "span",
          {
            staticClass: "status-badge",
            class: _vm.statusClass(_vm.item.status),
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.statusText(_vm.item.status)) + "\n    "
            ),
          ]
        ),
        _c("time", [_vm._v(_vm._s(_vm.item.time || "-"))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }